module.exports = "/images/vendor/vue-paycard/src/mir.png?7fc5060350930d404adb54b07c054e24";